import { dsFont } from "./styles";

type Props = {
  message: string;
  open: boolean;
};

/** Bottom-centre notice. Ink background, 13px. Caller owns the message. */
export function Toast({ message, open }: Props) {
  if (!open || !message) return null;
  return (
    <div
      role="status"
      data-ds=""
      data-testid="ds-toast"
      className={`${dsFont} pointer-events-none fixed bottom-6 left-1/2 z-50 max-w-[calc(100vw-32px)] -translate-x-1/2 rounded-ds-pill bg-ds-ink px-5 py-[11px] text-center text-ds-item font-normal text-ds-bg-a`}
    >
      {message}
    </div>
  );
}
